import styled from 'styled-components';

import { MediaQuery } from '../../constants/Styles';

export const Wrapper = styled.div`
  margin-bottom: ${({ hasItems }) => (hasItems ? '90px' : '0px')};

  ${MediaQuery.L_AND_DOWN} {
    margin-bottom: ${({ hasItems }) => (hasItems ? '60px' : '0px')};
  }
`;
